import { type CSSObject } from '@mantine/core';
import { textVariants } from '../../tokens/typography/typography';

export type { BadgeProps } from '@mantine/core';
export { Badge as default } from '@mantine/core';

export const BADGE_LIGHT_STYLES = {
	root: {
		border: 0
	},
	inner: {
		...( textVariants[ 'caption-semibold' ] as CSSObject )
	}
};
